import { Toaster } from './toast';

export class ErrorHandler {
  public static errorResponseHandler(error: any) {
    // if has response show the error
    if (error.response.status === 500) {
      window.hideLoader();
      Toaster.error('حدث خطأ في النظام');
      return Promise.reject(error);
    } if (error.response.status === 409) {
      window.hideLoader();
      Toaster.error(error.response.data);
      return Promise.reject(error);
    } if (error.response.status === 400) {
      window.hideLoader();
      if (typeof error.response.data === 'string') {
        if (error.response.data !== '') {
          Toaster.error(error.response.data);
        }
      } else {
        Toaster.error('حدث خطأ في النظام');
      }
      return Promise.reject(error);
    } if (error.response.status === 404) {
      window.hideLoader();
      if (typeof error.response.data === 'string') {
        if (error.response.data !== '') {
          Toaster.error(error.response.data);
        } else {
          Toaster.error('حدث خطأ في النظام');
        }
        return Promise.reject(error);
      }
      // else{
      //     window.hideLoader();
      //     Toaster.error(error.response.data);
      //     return Promise.reject(error);
      // }
    }
  }
}
